import { render, staticRenderFns } from "./MatrixReport.vue?vue&type=template&id=553e2d22&scoped=true"
import script from "./MatrixReport.vue?vue&type=script&lang=js"
export * from "./MatrixReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e2d22",
  null
  
)

export default component.exports